export default "__VITE_ASSET__BSQ6gxUK__"